<template>
  <SheetModal
    size="Hug"
    theme="Light"
    @close="emit('close')"
  >
    <div class="EditUserModalView__layout">
      <header class="EditUserModalView__header">
        <UIText
          tag="h2"
          size="2XLarge"
          weight="Medium"
        >
          What’s your name?
        </UIText>

        <UIText tag="p">
          Before {{ action }}, we need more information about you.
        </UIText>
      </header>

      <EditUserForm
        :profile="mergedProfile"
        :email="currentUser?.Email"
        :disabled="isRequesting"
        v-bind="{visibleFields}"
        @submit="handleSubmit"
      />
    </div>
  </SheetModal>
</template>

<script lang="ts" setup>
import useAuthStore from "@cosine/stores/useAuthStore";
import useRequest from "@cosine/composables/useRequest";
import { computed } from "vue";
import SheetModal from "@cosine/components/SheetModal.vue";
import EditUserForm from "@cosine/components/EditUserForm.vue";

import useAppSpinner from "@cosine/composables/useAppSpinner";
import useUserProfileStore from "@cosine/stores/useUserProfileStore";
import { IUserProfileModel } from "@cosine/types/api-models";
import { storeToRefs } from "pinia";
import { onMounted } from "vue";
import UIText from "@cosine/components/UIText.vue";
import { UserFormField } from "@cosine/components/EditUserForm.types";

const emit = defineEmits<{
  close: [],
  submit: [],
}>();

defineProps<{
  action: string,
  visibleFields?: Array<UserFormField>,
}>();

const authStore = useAuthStore();
const userProfileStore = useUserProfileStore();
const {
  fetchUserProfile,
  updateUserProfile,
} = userProfileStore;
const {
  currentUserProfile,
} = storeToRefs(userProfileStore);
const {
  currentUser,
} = storeToRefs(authStore);

const {
  isRequesting,
  handleRequest,
} = useRequest();
useAppSpinner(isRequesting);

async function handleSubmit (updatedProfile: IUserProfileModel) {
  await handleRequest(updateUserProfile(updatedProfile), {
    showAlerts: true,
  });

  emit("submit");
}

onMounted(() => {
  handleRequest(fetchUserProfile());
});

const mergedProfile = computed(() => ({
  ...currentUserProfile.value,
  FirstName: currentUserProfile.value?.FirstName || currentUser.value?.FirstName,
  OtherNames: currentUserProfile.value?.OtherNames || currentUser.value?.LastName,
}));
</script>

<style lang="scss" scoped>
.EditUserModalView__layout {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 4px;

  color: var(--colorSwissBlack);
}

.EditUserModalView__header {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px 20px 0;
}
</style>
